import { Component } from "@angular/core";
import { CommonModule } from "@angular/common";
import { BaseModalComponent } from "../base-modal/base-modal.component";
import { MatDialogRef } from "@angular/material/dialog";
import { Router } from "@angular/router";

@Component({
  selector: "app-dialog-onboarding-promo",
  standalone: true,
  imports: [CommonModule, BaseModalComponent],
  templateUrl: "./dialog-onboarding-promo.component.html",
  styleUrls: ["./dialog-onboarding-promo.component.scss"],
})
export class DialogOnboardingPromoComponent {
  constructor(
    private dialogRef: MatDialogRef<DialogOnboardingPromoComponent>,
    private router: Router
  ) {}

  closeDialog(route: string = "") {
    this.dialogRef.close();
    if (route) {
      this.router.navigate([route]);
    }
  }
}
